import { request } from '@trp-individual-investor-adv-disc/adv-shared';

const discretionaryService = {
    getInvestmentProposalAllClient(applicationConfig, userId) {
        return request(
            applicationConfig,
            '/adv-disc-svc/service/investment-proposal/v1/client/all',
            'get',
            userId === undefined ?
                {} :
                { 'x-trp-user-id': userId, 'trp-request-delegated-user': userId },
            null,
            '/usis/advice/checkout'
        );
    },
    saveInvestmentProposalScreenCapture(applicationConfig, formDataPdf) {
        return request(
            applicationConfig,
            '/adv-disc-svc/service/investment-proposal/v1/proposal',
            'post',
            { 'Content-Type': 'multipart/form-data' },
            formDataPdf,
            '/usis/advice/checkout'
        );
    },
    sendInvestmentProposalScreenCaptureFailure(applicationConfig) {
        return request(
            applicationConfig,
            '/adv-disc-svc/service/investment-proposal/v1/proposal/error/trace',
            'get',
            {},
            null,
            '/usis/advice/checkout',
            false
        );
    }
};

export default discretionaryService;
